import React from 'react';

export type LifecycleStatusFilter = 'active' | 'inactive' | 'all';

/**
 * The standard Active/Deactivated/All filter for Accounts lists
 * (ACCOUNTS_TOOL_REQUIREMENTS.md §3.0 — deactivated entities are one filter
 * away, never invisible).
 */
const StatusFilter: React.FC<{
  value: LifecycleStatusFilter;
  onChange: (value: LifecycleStatusFilter) => void;
}> = ({ value, onChange }) => (
  <select
    value={value}
    onChange={(event) => onChange(event.target.value as LifecycleStatusFilter)}
    aria-label="Filter by status"
    className="h-9 rounded-lg border border-border-light bg-white px-2 text-sm text-text-primary dark:border-border-dark dark:bg-background-dark-secondary dark:text-text-dark-primary"
  >
    <option value="active">Active</option>
    <option value="inactive">Deactivated</option>
    <option value="all">All statuses</option>
  </select>
);

export default StatusFilter;
